import { FC, ReactNode } from "react";

import Header from "./header";

export const ScreenMainHeader: FC<{
  title: string | ReactNode;
  route?: string;
}> = ({ title }) => {
  return (
    <div className="flex justify-between md:items-center md:flex-row flex-col-reverse">
      <h1 className="text-3xl leading-none font-bold tracking-tight">
        {title}
      </h1>

      <Header />
    </div>
  );
};
